/** @deprecated - play screen config is now managed locally in src/app/screens/play-screen/playTabConfig.ts */

import { z } from 'zod'

export const playScreenModuleNames = z.enum([
  'pokerish',
  'firstGame',
  'communityGames',
  'practiceGame',
  'createGame',
  'lounges',
  'yourGames',
  'joinGame',
  'handRankings',
  'badges'
])

const playScreenConfigSchemaBase = z.object({
  modules: z.array(
    z.object({
      name: playScreenModuleNames,
      enabled: z.boolean().default(true),
      paddingTop: z.number().default(32),
      paddingBottom: z.number().default(0)
    })
  ),
  variation: z.enum(['default', 'variantA']).default('default')
})

type PlayScreenConfig = z.infer<typeof playScreenConfigSchemaBase>

const defaultConfig: PlayScreenConfig = {
  modules: [
    {
      name: 'pokerish',
      enabled: false,
      paddingTop: 48,
      paddingBottom: 0
    },
    {
      name: 'firstGame',
      enabled: true,
      paddingTop: 32,
      paddingBottom: 0
    },
    {
      name: 'practiceGame',
      enabled: true,
      paddingTop: 32,
      paddingBottom: 0
    },
    {
      name: 'joinGame',
      enabled: true,
      paddingTop: 8,
      paddingBottom: 0
    },
    {
      name: 'createGame',
      enabled: true,
      paddingTop: 8,
      paddingBottom: 0
    },
    {
      name: 'lounges',
      enabled: true,
      paddingTop: 8,
      paddingBottom: 0
    },
    {
      // Below lounges; remote config can disable it for rollout control.
      // Section spacing (like yourGames) since it renders a "Your Badges" header.
      name: 'badges',
      enabled: true,
      paddingTop: 32,
      paddingBottom: 0
    },
    {
      name: 'yourGames',
      enabled: true,
      paddingTop: 32,
      paddingBottom: 0
    },
    {
      name: 'communityGames',
      enabled: true,
      paddingTop: 32,
      paddingBottom: 0
    },
    {
      name: 'handRankings',
      enabled: false,
      paddingTop: 32,
      paddingBottom: 0
    }
  ],
  variation: 'default'
}

export const playScreenConfigSchema = playScreenConfigSchemaBase.default(defaultConfig)
